// extracted by mini-css-extract-plugin
export default {"container":"CompanyDialog_container__uOm19"};